import { customAxios, customPatchAxios } from "./customAxios";

// /**
//  * 설비상태별 건수
//  * @param {*} query 
//  * @returns 
//  */
// export const getEquipmentsGroupCountByStatus = async(query)=>{
//   const res = await customAxios.get('/api/equipments/:groupByStatus', {params : query});
//   //console.log(res);
//   if (res) {
//      //return Object.values(res.data);
//      return res;
//   }
//   return null;
// }

/**
 * 설비상태별 건수
 * @param {*} query 
 * @returns 
 */
export const getEquipmentsGroupCountByStatus = async(query)=>{
  const res = await customAxios.get('/api/equipments/countByStatus', {params : query});
  //console.log(res);
  if (res) {
     //return Object.values(res.data);
     return res;
  }
  return null;
}

/**
 * 설비상태별 건수(유지관리설비목록)
 * @param {*} query 
 * @returns 
 */
export const getEquipmentsCountGroupByStatus = async(query)=>{
  const res = await customAxios.get('/api/equipments/:countGroupByStatus', {params : query});
  //console.log(res);
  if (res) {
     //return Object.values(res.data);
     return res;
  }
  return null;
}

/**
 * 설비상태 및 검색조건별 건수(유지관리설비목록)
 * @param {*} query 
 * @returns 
 */
// export const getEquipmentsCountGroupByStatusAndSearch = async(query)=>{
//   const res = await customAxios.get('/api/equipments/:countGroupByStatus2', {params : query});
//   //console.log(res);
//   if (res) {
//      //return Object.values(res.data);
//      return res;
//   }
//   return null;
// }

/**
 * 설비 목록
 * @param {*} query 
 * @returns 
 */
export const getEquipmentsByQuery = async(query)=>{
  const res = await customAxios.get('/api/equipments', {params : query});
  //console.log(res);
  if (res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}

/**
 * 설비 상세
 * @param {*} id 
 * @returns 
 */
export const getEquipmentsById = async(id)=>{
  const res = await customAxios.get('/api/equipments/'+id);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 설비 진단요청
 * @param {*} id 
 * @returns 
 */
export const postEquipmentsExecuteDiagnosisById = async(id)=>{
  const res = await customAxios.post('/api/equipments/'+id+":executeDiagnosis");
  console.log(res);
}

/**
 * 설비 등록
 * @param {*} body 
 */
// export const postEquipments = async(body)=>{
//  //console.log(body);
//  await customAxios.post('/api/equipments',body);
// }

/**
 * 설비 비고 수정
 * @param {*} body 
 */
export const patchEquipmentRemark = async(body)=>{
 //console.log(body);
 await customPatchAxios.patch('/api/equipments/'+body.id+':simple', body);
}

/**
 * 설비 삭제
 * @param {*} param 
 */
export const deleteEquipments = async(param)=>{
 //console.log(param);
 const res = await customAxios.delete('/api/equipments/'+param);
 if (res) {
     return res.data;
  }
  return null;
}


/**
* 설비 개수
* @returns 
*/
export const getEquipmentsCount = async(query)=>{
  const res = await customAxios.get('/api/equipments/count', {params : query});
  //console.log(res);
  if (res) {
     return res.data;
  }
  return null;
}

/**
 * 설비스펙 목록(자재)
 * @param {*} query 
 * @returns 
 */
export const getEquipmentPartsByQuery = async(query)=>{
  const res = await customAxios.get('/api/equipmentParts', {params : query});
  //console.log(res);
  if (res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}

/**
 * 설비스펙 목록(자재)
 * @param {*} query 
 * @returns 
 */
export const getEquipmentPartsByQueryString = async(query)=>{
  const res = await customAxios.get('/api/equipmentParts'+query);
  //console.log(res);
  if (res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}

/**
 * 설비스펙 목록(자재스펙포함)
 * @param {*} query 
 * @returns 
 */
export const getEquipmentPartsEquipmentsByIdAndQuery = async(id,query)=>{
  const res = await customAxios.get('/api/equipmentParts/equipments/'+id, {params : query});
  //console.log(res);
  if (res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}

/**
 * 설비스펙 목록(자재스펙포함)
 * @param {*} query 
 * @returns 
 */
export const getEquipmentPartsAndSpecByQuery = async(query)=>{
  const res = await customAxios.get('/api/equipmentParts:withSpec', {params : query});
  //console.log(res);
  if (res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}

export const getEquipmentPartsAndSpecByQueryString = async(query)=>{
  const res = await customAxios.get('/api/equipmentParts:withSpec'+query);
  //console.log(res);
  if (res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}

/**
 * 설비구성부 목록
 * @param {*} query 
 * @returns 
 */
export const getEquipmentPartsWithSensorPositionByQuery = async(query)=>{
  const res = await customAxios.get('/api/equipmentParts:withSensorPosition', {params : query});
  //console.log(res);
  if (res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}

/**
 * 설비스펙 동종평균값 가져오기
 * @param {*} query 
 * @returns 
 */
export const getEquipmentPartHistoriesByQuery = async(query)=>{
  const res = await customAxios.get('/api/equipmentPartHistories', {params : query});
  // console.log(res);
  if (res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}

/**
 * 설비스펙 상세(자재)
 * @param {*} id 
 * @returns 
 */
export const getEquipmentPartsById = async(id)=>{
  const res = await customAxios.get('/api/equipmentParts/'+id);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 설비스펙 등록(자재)
 * @param {*} body 
 */
export const postEquipmentParts = async(body)=>{
 //console.log(body);
  const res = await customAxios.post('/api/equipmentParts',body);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 설비스펙 수정(자재)
 * @param {*} body 
 */
export const patchEquipmentParts = async(body)=>{
 //console.log(body);
 await customPatchAxios.patch('/api/equipmentParts/'+body.id, body);
}


/**
 * 설비spec 등록
 * @param {*} body 
 */ 
export const addSpecEquipmentParts = async(body)=>{
  //console.log(body);
  await customPatchAxios.patch('/api/equipmentParts/'+body.id+':addSpec', body);
}

/**
 * 설비spec 수정
 * @param {*} body 
 */ 
export const updateSpecEquipmentParts = async(body)=>{
  //console.log(body);
  await customPatchAxios.patch('/api/equipmentParts/'+body.id+':updateSpec', body);
}

/**
 * 설비spec 삭제
 * @param {*} body 
 */ 
export const deleteSpecEquipmentParts = async(body)=>{
  //console.log(body);
  await customPatchAxios.patch('/api/equipmentParts/'+body.id+':deleteSpec', body);
}


/**
 * 점검주기 업데이트
 * @param {*} body 
 */
export const patchEquipmentPartsReplace = async(body)=>{
  //console.log(body);
  await customPatchAxios.patch('/api/equipmentParts/'+body.id+':replace', body);
 }
 
/**
 * 설비스펙 삭제
 * @param {*} param 
 */
export const deleteEquipmentParts = async(param)=>{
 //console.log(param);
 await customAxios.delete('/api/equipmentParts/'+param);
}


/**
 * 설비스펙상세(스펙만)
 * @param {*} query 
 * @returns 
 */
export const getEquipmentPartsSpecOnlyById = async(id)=>{
  const res = await customAxios.get('/api/equipmentParts/'+id+':specOnly');
  //console.log(res);
  if (res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}

/**
 * 설비스펙수정
 * @param {*} body 
 */
export const patchEquipmentPartsSpec = async(body)=>{
  //console.log(body);
  await customPatchAxios.patch('/api/equipmentParts/'+body.id, body);
}

/**
 * 설비스펙 가져오기(다른 설비의 스펙 복사)
 * @param {*} query 
 * @returns 
 */
export const getEquipmentPartCopySpecsByQuery = async(query)=>{
  const res = await customAxios.get('/api/equipmentParts/copySpecs', {params : query});
  // console.log(res);
  if (res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}

/**
 * 설비에 모뎀 연결정보 변경
 * @param {*} body 
 */
export const replaceEquipmentModems = async(body)=>{
  //console.log(body);
  await customPatchAxios.patch('/api/modems/'+body.id+':replace', body);
}

/**
 * 설비에 게이트웨이 등록
 * @param {*} body 
 */
export const installEquipmentGateways = async(body)=>{
  //console.log(body);
  await customPatchAxios.patch('/api/iotGateways/'+body.id+':install', body);
}

/**
 * 설비에 게이트웨이 해제
 * @param {*} body 
 */
export const uninstallEquipmentGateways = async(body)=>{
  //console.log(body);
  await customPatchAxios.patch('/api/iotGateways/'+body.id+':uninstall', body);
}

/**
 * 설비에 게이트웨이 연결정보 변경
 * @param {*} body 
 */
export const replaceEquipmentGateways = async(body)=>{
  //console.log(body);
  await customPatchAxios.patch('/api/iotGateways/'+body.id+':replace', body);
}

/**
 * 설비 게이트웨이에 센서 등록
 * @param {*} body 
 */
export const installEquipmentSensors = async(body)=>{
  //console.log(body);
  await customPatchAxios.patch('/api/sensors/'+body.id+':install', body);
}

/**
 * 설비 게이트웨이에 센서 해제
 * @param {*} body 
 */
export const uninstallEquipmentSensors = async(body)=>{
  //console.log(body);
  await customPatchAxios.patch('/api/sensors/'+body.id+':uninstall', body);
}

/**
 * 설비에 센서 연결정보 변경
 * @param {*} body 
 */
export const replaceEquipmentSensors = async(body)=>{
  //console.log(body);
  await customPatchAxios.patch('/api/sensors/'+body.id+':replace', body);
}

/**
 * 설비 센서정보 수정
 * @param {*} body 
 */
export const patchEquipmentSensors = async(body)=>{
  //console.log(body);
  await customPatchAxios.patch('/api/sensors/'+body.id, body);
}

/**
 * 설비 현황 목록
 * @param {*} query 
 * @returns 
 */
export const getEquipmentStatusesByQuery = async(query)=>{
  const res = await customAxios.get('/api/equipmentStatuses', {params : query});
  //console.log(res);
  if (res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}


/**
 * 설비 현황 등록
 * @param {*} body 
 */
export const postEquipmentStatuses = async(body)=>{
  //console.log(body);
  await customAxios.post('/api/equipmentStatuses',body);
}

/**
* 설비 현황 수정
* @param {*} body 
*/
export const patchEquipmentStatuses = async(body)=>{
  //console.log(body);
  await customPatchAxios.patch('/api/equipmentStatuses/'+body.id, body);
}

/*********************************************/

/**
 * 제어반 목록
 * @param {*} query 
 * @returns 
 */
export const getLiftControlPanelsQuery = async(query)=>{
  const res = await customAxios.get('/api/controlPanels', {params : query});
  //console.log(res);
  if (res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}


/**
 * 제어반 로그 목록
 * @param {*} query 
 * @returns 
 */
export const getLiftOpLogsQuery = async(query)=>{
  const res = await customAxios.get('/api/integrated-diagnosis-logs', {params : query});
  // const res = await customAxios.get('/api/equipmentOpLogs', {params : query});
  //console.log(res);
  if (res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}


/**
 * 제어반 운전이력 로그 목록
 * @param {*} query 
 * @returns 
 */
export const getEquipmentOpLogsTimeline = async(equipmentId, query)=>{
  const res = await customAxios.get(`/api/equipmentOpLogs/${equipmentId}/timeline`, {params : query});
  // console.log(res);
  if (res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}

/**
 * 설비구역별 설비목록
 * @param {*} query 
 * @returns 
 */
export const getEquipmentsByZone = async(zoneId)=>{
  const res = await customAxios.get('/api/equipments/zone/'+zoneId);
  //console.log(res);
  if (res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}

/**
 * 설비구역별 설비대분류목록
 * @param {*} query 
 * @returns 
 */
export const getEquipmentCtgr1ByZone = async(query)=>{
  const res = await customAxios.get('/api/equipments/equipmentCtgr1', {params : query});
  //console.log(res);
  if (res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}

/**
 * 최근 측정 로그 목록
 * @param {*} query 
 * @returns 
 */
export const getEquipmentMeasurementLogsLatestQuery = async(query)=>{
  const res = await customAxios.get('/api/measurement/logs/latest', {params : query});
  //console.log(res);
  if (res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}

/**
 * 측정 비교 로그 목록
 * @param {*} query 
 * @returns 
 */
export const getEquipmentMeasurementLogsStatsComparisonQueryString = async(periodType, queryString)=>{
  const res = await customAxios.get('/api/measurement/logs/stats/comparison/'+periodType+queryString);
  //console.log(res);
  if (res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}

/**
 * 측정 가동시간 로그 목록
 * @param {*} query 
 * @returns 
 */
export const getEquipmentMeasurementLogsStatsDurationQueryString = async(periodType, queryString)=>{
  const res = await customAxios.get('/api/measurement/logs/stats/duration/'+periodType+queryString);
  //console.log(res);
  if (res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}

/**
 * 설비 OP 가동시간 로그 목록
 * @param {*} query 
 * @returns 
 */
export const getEquipmentOpLogsStatsOpStatusDurationQueryString = async(periodType, queryString)=>{
  const res = await customAxios.get('/api/equipmentOpLogs/stats/op-status/duration/'+periodType+queryString);
  //console.log(res);
  if (res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}


/**
 * 설비 OP 가동시간 로그 목록(운전상태별, 구동자재별)
 * @param {*} query 
 * @returns 
 */
export const getMeasurementLogsStatsDurationQueryString = async(periodType, queryString)=>{
  const res = await customAxios.get('/api/measurement/logs/stats/duration/'+periodType+queryString);
  //console.log(res);
  if (res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}

/**
 * 단일 설비 통신 상태 조회
 * 2026-04-28
 * @param {*} query 
 * @returns 
 */
export const getEquipmentAliveStatusById = async(id)=>{
  const res = await customAxios.get(`/api/equipments/${id}/alive-status`);
  //console.log(res);
  if (res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}

/**
 * 복수 설비 통신 상태 일괄 조회
 * 2026-04-28
 * @param {*} query 
 * @returns 
 */
export const getEquipmentAliveStatusesByQuery = async(query)=>{
  const res = await customAxios.get(`/api/equipments/alive-statuses`, {params : query});
  //console.log(res);
  if (res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}

/**
 * 설비 목록 검색(키워드 , 구분)
 * 2026-07-20 dh
 * @param {*} query 
 * @returns 
 */
export const getEquipmentsByCommaKeyword = async(query)=>{
  const res = await customAxios.get('/api/equipments/search', {params : query});
  //console.log(res);
  if (res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}